export default __webpack_public_path__ + "static/media/green-polygon.5708e018.svg";